function OfficePromise(handler) {
  return new Promise((resolve, reject) => {
    handler((result) => {
      console.log(result);
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(result.error);
      }
    });
  });
}

export function getUserIdentityToken() {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.getUserIdentityTokenAsync(result => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        // https://docs.microsoft.com/en-us/javascript/api/office/office.asyncresult?view=common-js-preview
        const { error, diagnostics } = result;
        switch (error.name) {
          case "NetworkError":
            reject(Error("Network error. Please check your network connection and try again."));
            break;
          case "HTTPRequestFailure":
            reject(Error(`Error code ${diagnostics.HTTPCode}`));
            break;
          case "InternalServerError":
            reject(diagnostics.ErrorText);
            break;
        }
      }
    });
  });
}

export function displayDialog(startAddress, options) {
  return OfficePromise((callback) => Office.context.ui.displayDialogAsync(startAddress, options, callback));
}

export function getItemBodyType() {
  return OfficePromise((callback) => Office.context.mailbox.item.body.getTypeAsync(callback));
}

export function getItemBody(coercionType) {
  return OfficePromise((callback) => Office.context.mailbox.item.body.getAsync(coercionType, null, callback));
}

export function setItemBody(data, options) {
  return OfficePromise((callback) => Office.context.mailbox.item.body.setAsync(data, options, callback));
}

export function getItemSubject() {
  return OfficePromise((callback) => Office.context.mailbox.item.subject.getAsync(callback));
}

export function getItemStart() {
  return OfficePromise((callback) => Office.context.mailbox.item.start.getAsync(callback));
}

export function setInfoMessage(message) {
  Office.context.mailbox.item.notificationMessages.replaceAsync("action", {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    message,
    icon: "Icon.80x80",
    persistent: true,
  });
}

class ItemProps {
    constructor(props) {
        this.props = props;
    }

    async set(key, value) {
        this.props.set(key, value);
        return new OfficePromise(callback => this.props.saveAsync(callback));
    }

    async remove(key) {
        this.props.remove(key);
        return new OfficePromise(callback => this.props.saveAsync(callback));
    }

    get(key) {
        return this.props.get(key);
    }
}

export async function loadItemProps() {
    try {
        const itemProps = await new OfficePromise(
            callback => Office.context.mailbox.item.loadCustomPropertiesAsync(callback));
        return new ItemProps(itemProps);
    } catch (e) {
        console.error(e);
        throw Error("Failed to load item props")
    }
}